import(/* webpackMode: "eager" */ "/app/components/blogs/article.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
